
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'

import { encrypt } from '@/utils/Crypto'

export default {
components: {
CheckIcon,
XInput,
XButton,
XDialog,
XHeader
},
name: "Register",
data() {
return {

userRegister: {
phonenumber: "",
password: "",
confirPass: "",
},

showCodeTab: false,
codeImg: "",
imgCode: "",
buttonCodeText: "获取验证码",
isCodeDisabled: false,

passwordType: "password",

isAgree: true,

inputFocus: [false, false, false],
isFormValid: false,
msg: ""
};
},
computed: {

isPhoneValid() {
return /^1[3-9]\d{9}$/.test(this.userRegister.phonenumber);
}
},
watch: {

'userRegister.phonenumber'() {
this.validateForm();
},
'userRegister.password'() {
this.validateForm();
},
'userRegister.confirPass'() {
this.validateForm();
},

},
methods: {

togglePasswordVisibility() {
this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
},


onInputFocus(index) {
this.inputFocus = this.inputFocus.map((_, i) => i === index);
},

onInputBlur(index) {
this.inputFocus[index] = false;
},


validateForm() {
const { phonenumber, password, confirPass} = this.userRegister;
const isPhoneValid = /^1[3-9]\d{9}$/.test(phonenumber);
const isPasswordValid = password.length >= 6 && password.length <= 20;
const isConfirmValid = confirPass === password && confirPass !== "";

this.isFormValid = isPhoneValid && isPasswordValid && isConfirmValid ;
},


refreshCode() {
this.getAuthtCode();
},


getAuthtCode() {
if (!this.isPhoneValid) {
this.msg = "请输入正确的手机号";
this.showToast();
return;
}

this.$ajax
.post(
this.$api.getAuthCodeImg,
{ ...this.userRegister },
{ responseType: "blob" }
)
.then((result) => {
this.showCodeTab = true;
this.codeImg = window.URL.createObjectURL(result);
})
.catch(err => {
console.error("获取验证码失败:", err);
});
},


getphoneCode() {
if (!this.imgCode) {
this.msg = "请输入图形验证码";
this.showToast();
return;
}

this.$ajax
.get(this.$api.getphoneCode, {
params: {
phonenumber: this.userRegister.phonenumber,
imgCode: this.imgCode
}
})
.then((result) => {
if (result.data === "验证成功") {
this.showCodeTab = false;
this.startCountdown();
this.$toast("验证码已发送");
} else {
this.msg = "图形验证码错误，请重新输入";
this.showToast();
this.refreshCode();
}
})
.catch(err => {
this.msg = "获取验证码失败，请重试";
this.showToast();
});
},


startCountdown() {
this.isCodeDisabled = true;
let countdown = 60;
const timer = setInterval(() => {
countdown--;
this.buttonCodeText = `重新发送(${countdown}s)`;

if (countdown <= 0) {
clearInterval(timer);
this.buttonCodeText = "获取验证码";
this.isCodeDisabled = false;
}
}, 1000);
},


showToast() {
Toast({
message: this.msg,
position: 'top',
duration: 2000
});
toast.show();
},


register() {

if (!this.isPhoneValid) {
this.msg = "请输入正确的手机号";
this.showToast();
return;
}

if (this.userRegister.password.length < 6) {
this.msg = "密码长度不能少于6位";
this.showToast();
return;
}

if (this.userRegister.password !== this.userRegister.confirPass) {
this.msg = "两次输入的密码不一致";
this.showToast();
return;
}




this.userRegister.password = this.userRegister.password;
this.userRegister.username = this.userRegister.phonenumber;


this.$ajax
.post(this.$api.register, { ...this.userRegister })
.then((result) => {
this.$toast("注册成功，即将跳转到登录页");
setTimeout(() => {
this.$router.push({
path: "/sysLogin_display",
query: { username: this.userRegister.username }
});
}, 1500);
})
.catch(err => {
this.msg = "注册失败，请重试";
this.showToast();
console.error("注册失败:", err);
});
},


goLogin() {
this.$router.push({ path: "/sysLogin_display" });
},


handleUserAgrement() {
this.$router.push({
path: '/yhfwxy_display',
query: { title: "用户协议", url: "https://www.wordkillstu.com.cn/datainfo/用户服务条款.html" }
});
},


handlePrivacy() {
this.$router.push({
path: '/yhfwxy_display',
query: { title: "隐私协议", url: "https://www.wordkillstu.com.cn/datainfo/隐私条款.html" }
});
},


showToast() {
this.$toast({
message: this.msg,
position: 'top',
duration: 2000
});
},


cancelCode() {
this.showCodeTab = false;
this.imgCode = "";
}
}
};



// WEBPACK FOOTER //
// ./src/views/sys/Register.vue